import React, { FunctionComponent, ReactNode } from "react";
import PropTypes from "prop-types";
import Wrapper from "./styles/rating-emoji-styles";

interface IRatingEmojiProps {
  rating?: number;
}

const RatingEmoji: FunctionComponent<IRatingEmojiProps> = ({ rating }) => {
  let emoji: ReactNode;

  switch (rating) {
    case 1:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated jackInTheBox delay"
        >
          😟
        </span>
      );
      break;
    case 2:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated jackInTheBox delay"
        >
          😐
        </span>
      );
      break;
    case 3:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated rollIn delay"
        >
          🙂
        </span>
      );
      break;
    case 4:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated tada delay"
        >
          😉
        </span>
      );
      break;
    case 5:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated tada delay"
        >
          🤩
        </span>
      );
      break;
    default:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animatedTwo fadeInDown delay"
        >
          🤔
        </span>
      );
      break;
  }
  return <Wrapper>{emoji}</Wrapper>;
};

RatingEmoji.propTypes = {
  rating: PropTypes.number,
};

RatingEmoji.defaultProps = {
  rating: null,
};

export default RatingEmoji;
